import Login from "../pages/Authentication/Login";
import ForgetPassword from "../pages/Authentication/ForgetPassword";
import Category from "../Category/Category";
import Dashboard from "../pages/dashboard/Dashboard";
import ResetPassword from "../pages/Authentication/ResetPassword";
import AddCategory from "../Category/AddCategory";
import EditCategory from "../Category/EditCategory";
import ViewCategory from "../Category/ViewCategory";
import Product from "../Product/Product";
import AddProduct from "../Product/AddProduct";
import EditProduct from "../Product/EditProduct";
import ViewProduct from "../Product/ViewProduct";
import OrderList from "../Orders/OrderList";
import ViewOrder from "../Orders/ViewOrder";
import UserList from "../Users/UserList";
import ViewUser from "../Users/ViewUser";
import Register from "../pages/Authentication/Register"
import UserLogin from "../Landing_page/Authentication/UserLogin"
import UserNavber from "../Landing_page/Component/Navbar.jsx/UserNavber";

export const authRoutes = [
    {path: "/", component: <Dashboard/>},
    {path: "/category", component: <Category/>},
    {path: "/dashboard", component: <Dashboard/>},
    {path: "/add-category", component: <AddCategory/>},
    {path: "/edit-category/:id", component: <EditCategory/>},
    {path: "/category/view/:id", component: <ViewCategory/>},
    {path: "/product", component: <Product/>},
    {path: "/add-product", component: <AddProduct/>},
    {path: "/edit-product/:id", component: <EditProduct/>},
    {path: "/product/view/:id", component: <ViewProduct/>},
    {path: "/orders", component: <OrderList/>},
    {path: "/view-order/:id", component: <ViewOrder/>},
    {path: "/users", component: <UserList/>},
    {path: "/view-user/:id", component: <ViewUser/>},
];

export const publicRoutes = [
   {path: "/login", component:<Login/>},
   {path: "/forget-password", component: <ForgetPassword/>},
   {path: "/reset-password", component: <ResetPassword/>},
   {path: "/user-login", component:<UserLogin/>},
   {path: "/register", component:<Register/>},
];

export const userRoute = [
    {path: "/user-navbar", component: <UserNavber/>}
]
// export default {publicRoutes, authRoutes};
 